import { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert';

//components
import withPermissions from '~/hoc/withPermissions';
import withLocalization from '~/hoc/withLocalization';
import applicationRouter from '~/hoc/applicationRouter';
import ModalEditor from './ProjectMembersForm';
import GenericFilter from '../../../components/GenericList/GenericFilter.js';
import GenericList from '~/components/GenericList/GenericList';
import ProjectView from './ProjectView';
import ProjectImport from './ProjectImport';
import ProjectTaskImport from './ProjectTaskImport.js';
//elements
import LoadingSpinner from '../../../elements/LoadingSpinner';
import Button from '../../../components/CustomButton/CustomButton.jsx';

//utils
import { shortDateFormat, totalTimeFormat } from '~/utils/dateFormat';
import { checkUserPermissions } from '../../../library/stores/userStore.js';
import { payrollIntegrationOptions, TRIPLETEX_PLANS } from '../../../utils/constants.js';

//assets
import Edit from '../../../assets/img/editing.svg';
import Delete from '../../../assets/img/deleting.svg';
import CloseModalIcon from '../../../assets/img/CloseApproveModalIcon.svg';
import Sync from '../../../assets/img/Sync.svg';
import { inviteSVG } from '../../../utils/constants.js'
import { getIntegrationProduct } from '../../../utils/integrationUtils.js';

class ProjectsList extends Component {
    constructor(props) {
        super(props);
        const { page, isEdit, lastInteractedId } = this.props.router.location.state || {};
        if (lastInteractedId) {
            this.props.projectStore.setLastInteractedId(lastInteractedId);
        }
        this.hasIntegrationSupport = [payrollIntegrationOptions.TRIPLETEX, payrollIntegrationOptions.XLEDGER, payrollIntegrationOptions.VISMA]
            .includes(this.props.commonStore.config?.integration_details?.product);
        this.state = {
            nowEditingId: null,
            modalName: '',
            page: page ? page : 0,
            isPageAddedOrEdited: isEdit ? isEdit : false,
            showImportComponent: false,
            showSyncTaskModal: false,
            selectedProjectIntId: null,
            selectedProjectId: null,
            isProjectHoursLoading: false,
            pmRulesLoading: false,
            pmList: [],
            lastColoumLoadTime: new Date()
        }
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    componentDidMount() {
        const { projectStore } = this.props;
        projectStore.getProjectTotals();
    }

    componentWillUnmount() {
        this.props.projectStore.clearLastInteractedId();
    }
    handleTableButtonAction = (id, type, int_id, assignee_id, pmHasManageProjects) => {
        const { t } = this.props;
        this.props.projectStore.setLastInteractedId(id);

        if (type === 'view')
            return this.startEdit(id, 'project_view');

        if (type === 'clone') {
            return this.startEdit(id, 'tasks');
        }
        if (type === 'edit') {
            if (!this.validateRoleAccess('manage', assignee_id, pmHasManageProjects)) return this.startEdit(id, 'project_view');
            this.props.router.navigate(`/admin/projects/${id}`,
                { state: { projects: id, page: this.state.page, isEdit: this.state.isPageAddedOrEdited, lastInteractedId: id } });
        }
        if (type === 'remove') {
            this.props.projectStore.remove(id).then((res) => {
                let str = `${t('All data related to this project in Time & Control will be permanently deleted. Are you sure you want to proceed')}?
                ${t('It has some data filled')}. ${t('Tasks')}: ${res.tasks}, ${t('Timelog')}: ${res.timelogs}. `;
                if (int_id) {
                    str = `${t('The project will also be permanently deleted from your bookkeeping system. This means all related data within Time & Control will also be permanently removed. Are you sure you want to proceed with the deletion')}?
                    ${t('It has some data filled')}. ${t('Tasks')}: ${res.tasks}, ${t('Timelog')}: ${res.timelogs}.`;
                }
                confirmAlert({
                    title: this.props.t('Confirm to delete'),
                    message: str,
                    buttons: [
                        {
                            label: this.props.t('Yes'),
                            onClick: () => {
                                return this.props.projectStore.remove(id, true).then((res2) => {
                                    this.props.projectStore.resetLastListLoadTime();
                                    return res2;
                                });
                            },
                        },
                        {
                            label: this.props.t('No'),
                            onClick: () => { },
                        },
                    ],
                });
            });
        }
    };

    startEdit = (id, type) => {
        if (this.props.userStore.currentUser.user_type === 'member' && type !== 'project_view') return;
        this.props.projectStore.setLastInteractedId(id);
        this.setState({ nowEditingId: id, modalName: type });
    };

    getRowClassName = (row) => {
        if (row.id === this.props.projectStore.lastInteractedId) return 'interacted-row';
        return '';
    };

    handleSyncWithIntegration = (id) => {
        const { projectStore, t, commonStore } = this.props
        const str = t(`Do You want to Sync Project with Tripletex`);
        confirmAlert({
            title: this.props.t('Confirm to Sync'),
            message: str,
            buttons: [
                {
                    label: this.props.t('Yes'),
                    onClick: () => {
                        return projectStore.saveIntoIntegration({ id: id }).then((res2) => {
                            projectStore.resetLastListLoadTime();
                            commonStore.addNotification(t(res2.message), null, 'success');
                            return res2;
                        });
                    },
                },
                {
                    label: this.props.t('No'),
                    onClick: () => { },
                },
            ],
        })
    }

    sendInviteToContactPerson = async (id, email) => {
        const { projectStore, t, commonStore } = this.props
        if (!email)
            return commonStore.addNotification(t('Email must needed to invite contact person'), null, 'error');
        const str = t(`Are you sure you want to invite contact person`) + '?';
        confirmAlert({
            title: this.props.t('Confirm the action'),
            message: str,
            buttons: [
                {
                    label: this.props.t('Yes'),
                    onClick: () => {
                        return projectStore.sendInviteToContactPerson({ id }).then((res2) => {
                            commonStore.addNotification(t(res2.message), null, 'success');
                            return res2;
                        });
                    },
                },
                {
                    label: this.props.t('No'),
                    onClick: () => { },
                },
            ],
        })
    }

    renderTableActionButtons = (id, aclAllowed, t, status, int_id, assignee_id, email, payroll_project_id, data, pmHasManageProjects) => (
        <div className="actions-center">
            {(this.hasIntegrationSupport && status === 'active') ? int_id ?
                <img src={getIntegrationProduct(this.props.commonStore.config?.integration_details?.product)}
                    width={20} height={20} alt='integration logo'
                    title={`${this.props.t('Synced with')} ${this.props.commonStore.config?.integration_details?.product}`}
                />
                :
                this.props.commonStore.config?.integration_details?.product === payrollIntegrationOptions.TRIPLETEX && !this.props.commonStore.config?.integration_details?.integration_settings?.useGeneralActivitiesForTimesheet ? (<OverlayTrigger
                    key="sync-projects"
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">{!this.validateRoleAccess('manage', assignee_id, pmHasManageProjects) ?
                        t("You don't have enough rights to perform this action") : t('Sync with integration')}
                    </Tooltip>}
                >
                    <Button icon_sm fill
                        disabled={!this.validateRoleAccess('manage', assignee_id, pmHasManageProjects)}
                        onClick={() => this.handleSyncWithIntegration(id)}>
                        <img src={Sync} alt='sync' />
                    </Button>
                </OverlayTrigger>) : null
                : null
            }
            {this.props.userStore.currentUser.user_type === 'admin' && this.props.commonStore.config?.integration_details?.product === payrollIntegrationOptions.XLEDGER &&
                <OverlayTrigger
                    key="sync-task"
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">{t('Sync Task From') + ` ${this.props.commonStore.config?.integration_details?.product}`}</Tooltip>}
                >
                    <Button icon_sm fill onClick={() => this.setState((state) => ({ showSyncTaskModal: !state.showSyncTaskModal, selectedProjectIntId: payroll_project_id, selectedProjectId: id }))}>
                        <i
                            className={`fa fa-tasks ${data?.hasTasks ? '' : 'font-color-primary'}`}
                            style={data.hasTasks ? { color: '#fd7e14' } : {}}
                        />
                    </Button>
                </OverlayTrigger>
            }
            {aclAllowed('project-edit') && this.props.commonStore.config?.client?.allow_customer_service_request && status === 'active' &&
                <OverlayTrigger
                    key="send-mail"
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">
                        {!this.validateRoleAccess('manage', assignee_id, pmHasManageProjects) ?
                            t("You don't have enough rights to perform this action") :
                            `${t('Invite')} ${t('Contact person')}`}
                    </Tooltip>}
                >
                    <Button icon_sm fill
                        disabled={!this.validateRoleAccess('manage', assignee_id, pmHasManageProjects)}
                        onClick={() => this.sendInviteToContactPerson(id, email)}>
                        {inviteSVG({ width: '1.3em', fillColor: "#2550ac" })}
                    </Button>
                </OverlayTrigger>
            }
            <OverlayTrigger
                key="view_project"
                placement="top"
                overlay={<Tooltip id="tooltip-top">{t("View details")}</Tooltip>}
            >
                <Button icon_sm fill onClick={() => this.handleTableButtonAction(id, 'view')}>
                    <i className="fa fa-align-left font-color-primary" />
                </Button>
            </OverlayTrigger>
            {aclAllowed('project-edit') && (
                <OverlayTrigger
                    key="update_project"
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">
                        {!this.validateRoleAccess('manage', assignee_id, pmHasManageProjects) ?
                            t("You don't have enough rights to perform this action") : t("Update Details")}
                    </Tooltip>}
                >
                    <Button
                        icon_sm fill
                        onClick={() => this.handleTableButtonAction(id, 'edit', null, assignee_id, pmHasManageProjects)}
                        disabled={!this.validateRoleAccess('manage', assignee_id, pmHasManageProjects)}
                    >
                        <img src={Edit} alt={"edit button"} />
                    </Button>
                </OverlayTrigger>
            )}
            {aclAllowed('project-delete') && status === 'inactive' && (
                <OverlayTrigger
                    key="remove_project"
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">
                        {!this.validateRoleAccess('remove', assignee_id) ?
                            t("You don't have enough rights to perform this action") : t("Remove Project")}
                    </Tooltip>}
                >
                    <Button icon_sm_delete fill
                        disabled={!this.validateRoleAccess('remove', assignee_id)}
                        onClick={() => this.handleTableButtonAction(id, 'remove', int_id)}>
                        <img src={Delete} alt="delete button" />
                    </Button>
                </OverlayTrigger>
            )}
        </div>
    );

    afterChangeMembers() {
        this.props.projectStore.setFilter('reloadTime', new Date().toString());
        this.props.projectStore.onFilter();
        this.props.projectStore.resetLastListLoadTime();
        this.setState({ nowEditingId: null, modalName: '' });
    }

    //handles generic list page change//
    handlePageChange = (page, isEdit) => {
        this.setState({ page, isPageAddedOrEdited: isEdit });
    };

    handleHeaderTabs = (status) => {
        if (this.isHeaderTabActive(status)) return;
        this.props.projectStore.setFilter('status', status)
        this.props.projectStore.onFilter();
    }

    isHeaderTabActive = (status) => {
        const { appliedFilters } = this.props.projectStore;
        return appliedFilters.status === status
    }

    handleImportModal = (state) => {
        this.setState({ showImportComponent: state })
        this.props.projectStore.resetLastListLoadTime();
    }

    handleTaskImportModal = (state) => {
        this.setState({ showSyncTaskModal: state })
        this.props.projectStore.resetLastListLoadTime();
    }

    renderProjectHeader() {
        const { t, projectStore, commonStore } = this.props;
        const { projectCounts } = projectStore;
        const { page, isPageAddedOrEdited } = this.state;
        const { config } = commonStore;
        const integrationSettings = config?.integration_details?.integration_settings;
        const product = config?.integration_details?.product;
        const canImportProjects = product === payrollIntegrationOptions.XLEDGER
            || product === payrollIntegrationOptions.VISMA
            || (product === payrollIntegrationOptions.TRIPLETEX
                && !integrationSettings?.useGeneralActivitiesForTimesheet
                && (!integrationSettings?.packageName || integrationSettings.packageName === TRIPLETEX_PLANS.KOMPLETT));
        return (
            <Row className="align-content-center mt-2 gx-0">
                <Col xs={12} md={{ span: 12, offset: 0 }} lg={{ span: 7, offset: 0 }}>
                    <Row className="member_status__summary">
                        <Col
                            xs={4}
                            className="mt-2 mt-sm-0 justify-content-center justify-content-sm-end justify-content-lg-center"
                        >
                            <div className={`highlighted ${this.isHeaderTabActive("") ? 'active' : ""}`} role={'button'}
                                onClick={() => this.handleHeaderTabs("")}
                            >
                                {t('All')} {t('Projects')}: {projectCounts.allProjects || '...'}
                            </div>
                        </Col>
                        <Col
                            xs={4}
                            className="mt-2 mt-sm-0 justify-content-center justify-content-sm-start justify-content-lg-center"
                        >
                            <div
                                className={`highlightedgreen ${this.isHeaderTabActive("active") ? 'active' : ""}`}
                                role={'button'}
                                onClick={() => this.handleHeaderTabs("active")}
                            >
                                {t('Active')} {t('Projects')}: {projectCounts.activeProjects || '...'}
                            </div>
                        </Col>
                        <Col xs={4} className="mt-2 mt-sm-0 justify-content-center">
                            <div
                                className={`highlightedred ${this.isHeaderTabActive("inactive") ? 'active' : ""}`}
                                role={'button'}
                                onClick={() => this.handleHeaderTabs("inactive")}
                            >
                                {t('Inactive')} {t('Projects')}: {projectCounts.inactiveProjects || '...'}
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col
                    xs={12} lg={5}
                    className="mt-2 mt-lg-0 text-start text-lg-end"
                >
                    <Row className="gx-0 genericlist_header_xxl_auto justify-content-lg-end" >
                        {canImportProjects ?
                            <Col className="text-end">
                                <Button
                                    onClick={() => this.setState((state) => ({ showImportComponent: !state.showImportComponent }))}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 24 24" className='margin-right-10'>
                                        <path fill="#2550ac" d="M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8c0-1.11.89-2 2-2h4V4c0-1.11.89-2 2-2m4 4V4h-4v2h4m-2 3l-5 5h3v4h4v-4h3l-5-5Z"></path>
                                    </svg>
                                    {this.props.t('Import')}
                                </Button>
                            </Col>
                            : null
                        }
                        <Col xs={6} sm={{ span: 4, offset: 4 }} lg={{ span: 3, offset: 0 }} className="text-end">
                            <OverlayTrigger
                                key="add-project"
                                placement="left"
                                overlay={
                                    <Tooltip id="tooltip-top">
                                        {!this.validateRoleAccess('create', null) ?
                                            this.props.t("You don't have enough rights to perform this action")
                                            : this.props.t('Add Project')}</Tooltip>}
                            >
                                <Button fill wd
                                    onClick={() => this.props.onAdd(page, isPageAddedOrEdited, this.props.projectStore.currentList)}
                                    disabled={!this.validateRoleAccess('create', null)}
                                >
                                    <i className="fa fa-plus-circle fa-xl margin-right-10" />
                                    {this.props.t('Add new')}
                                </Button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }

    validateRoleAccess = (action, managerId, pmHasManageProjects = false) => {
        const userStore = this.props.userStore;
        switch (userStore.currentUser.user_type) {
            case 'member':
                return false;
            case 'pm':
                if (action !== 'remove' && pmHasManageProjects) return true;
                if (managerId)
                    return managerId === userStore.currentUser.id && checkUserPermissions('md_Project', action);
                return checkUserPermissions('md_Project', action);
            default:
                return true;
        }
    }

    handleViewHours = async (id) => {
        const { commonStore, projectStore, userStore } = this.props;
        const { currentUser } = userStore;
        try {
            let pmMembers = '';
            if (currentUser.user_type === 'pm' && currentUser?.Manages?.length) {
                pmMembers = currentUser.Manages.join(',');
            }
            await projectStore.getProjectTotalHours(id, pmMembers);
        } catch (error) {
            console.error(error);
            commonStore.addNotification(error.message || 'Something went wrong', null, 'error');
        }
        finally {
            this.setState({ isProjectHoursLoading: false, lastColoumLoadTime: new Date() });
        }
    }

    handleToggleFavorite = async (id) => {
        const { projectStore } = this.props;
        try {
            await projectStore.toggleProjectFavorite(id);
            projectStore.resetLastListLoadTime();
        } catch (e) {
            console.error(e);
        }
    }

    openPmRulesModal = async (id) => {
        this.setState({ pmRulesLoading: true, nowEditingId: id, modalName: 'pm_rules' });
        try {
            const result = await this.props.projectStore.getProjectPmList(id);
            this.setState({ pmList: result || [], pmRulesLoading: false });
        } catch (e) {
            this.setState({ pmRulesLoading: false, pmList: [] });
        }
    }

    render() {
        const { projectStore, commonStore, aclAllowed, t, userStore } = this.props;
        const { nowEditingId, modalName, page, isPageAddedOrEdited,
            showImportComponent, showSyncTaskModal, selectedProjectIntId,
            selectedProjectId, isProjectHoursLoading, pmRulesLoading, pmList, lastColoumLoadTime } = this.state;
        const { loading, filters, appliedFilters, projectTotalHours } = projectStore;
        const { config } = commonStore;
        const statusOptions = config?.client?.data?.project_statuses || [];
        const dateTimeRules = commonStore.getDateTimeRules();
        const user_type = userStore.currentUser.user_type;
        const product = config?.integration_details?.product;
        const includeIntegrationDetails = !!product;

        return (
            <Fragment>
                <GenericList
                    columns={[
                        {
                            Header: '#',
                            id: 'project_number',
                            accessor: ({ project_number }) => (<span>{project_number || ''}</span>),
                            isSortable: true,
                            maxWidth: 50,
                            minWidth: 70,
                            textAlign: 'start',
                        },
                        {
                            Header: 'Employer / Project',
                            id: 'name',
                            accessor: ({ id, name, assignee_id, pm_has_manage_projects, is_favorite }) => (
                                <span title={name} className="d-flex align-items-center gap-1">
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip id={`fav-tooltip-${id}`}>{is_favorite ? t('Unfavorite') : t('Favorite')}</Tooltip>}
                                    >
                                        <i
                                            role="button"
                                            className={`fa fa-star cursor-pointer ${is_favorite ? 'text-warning' : 'text-muted'}`}
                                            onClick={(e) => { e.stopPropagation(); this.handleToggleFavorite(id); }}
                                        />
                                    </OverlayTrigger>
                                    <button
                                        role='link'
                                        style={{ border: 0 }}
                                        className="list-main-column"
                                        onClick={() => this.handleTableButtonAction(id, 'edit', null, assignee_id, !!pm_has_manage_projects)}
                                    >
                                        {name}
                                    </button>
                                </span>
                            ),
                            isSortable: true,
                            maxWidth: 100,
                            minWidth: 120,
                            textAlign: 'start',
                        },
                        {
                            Header: 'Last Updated',
                            id: 'updated_at',
                            accessor: ({ updated_at }) => updated_at && shortDateFormat(updated_at, dateTimeRules),
                            isSortable: true,
                            maxWidth: 70,
                            textAlign: "start"
                        },
                        {
                            Header: 'Location',
                            id: 'address',
                            accessor: ({ address, post_place, post_number }) => (
                                <span>
                                    {`${address ? `${address} ` : ''}${post_place ? `${post_place} ` : ''}${post_number ? `${post_number} ` : ''}`}
                                </span>
                            ),
                            maxWidth: 90,
                            textAlign: 'start',
                        },
                        user_type !== 'member' && {
                            Header: 'Members',
                            id: 'members_assigned',
                            accessor: ({ id, assignee_id, pm_has_manage_projects }) => (
                                <span>
                                    <OverlayTrigger
                                        key="assign-members"
                                        placement="bottom"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {!this.validateRoleAccess('manageMembers', assignee_id, !!pm_has_manage_projects) ?
                                                    t("You don't have enough rights to perform this action")
                                                    : `${t('Assign')} ${t('Members')}`}</Tooltip>}
                                    >
                                        <span
                                            role='button'
                                            className={`m-1 projectassignbtn ${this.validateRoleAccess('manageMembers', assignee_id, !!pm_has_manage_projects) ? 'cursor-pointer' : 'cursor-no-drop'}`}
                                            disabled={!this.validateRoleAccess('manageMembers', assignee_id, !!pm_has_manage_projects)}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (!this.validateRoleAccess('manageMembers', assignee_id, !!pm_has_manage_projects)) return;
                                                this.startEdit(id, 'assignees')
                                            }}
                                        >
                                            {t('Assign')}
                                        </span>
                                    </OverlayTrigger>
                                </span>
                            ),
                            maxWidth: 70,
                        },
                        {
                            Header: t('Direct Manager'),
                            id: 'assignee_id',
                            accessor: ({ assignee_id, manager_first_name, manager_last_name }) =>
                                <span>
                                    {assignee_id && manager_first_name && manager_last_name ? `${manager_first_name} ${manager_last_name}` : '-'}
                                </span>,
                            maxWidth: 80,
                            textAlign: 'start',
                        },
                        user_type !== 'member' && {
                            Header: t('Managers'),
                            id: 'pm_count',
                            accessor: ({ id }) => (
                                <OverlayTrigger
                                    key="view-managers"
                                    placement="bottom"
                                    overlay={<Tooltip id="tooltip-view-managers">{t('Click to view managers')}</Tooltip>}
                                >
                                    <span
                                        role="button"
                                        className="m-1 projectassignbtn cursor-pointer"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.openPmRulesModal(id);
                                        }}
                                    >
                                        {t('View Managers')}
                                    </span>
                                </OverlayTrigger>
                            ),
                            maxWidth: 100,
                        },
                        {
                            Header: 'Total Hours',
                            id: 'total_hours',
                            accessor: ({ id }) => (<>
                                {projectTotalHours && typeof projectTotalHours[id] === 'number' ?
                                    <span>{totalTimeFormat(projectTotalHours[id], dateTimeRules)}</span>
                                    :
                                    <OverlayTrigger
                                        key="check_hours"
                                        placement="bottom"
                                        overlay={
                                            <Tooltip id="tooltip-top">{t('Click to view total timesheet hours logged in this project')}</Tooltip>}
                                    >
                                        <span
                                            role='button'
                                            className={"m-1 projectassignbtn cursor-pointer"}
                                            disabled={isProjectHoursLoading}
                                            onClick={(e) => { e.stopPropagation(); this.props.projectStore.setLastInteractedId(id); this.setState({ isProjectHoursLoading: true }, () => this.handleViewHours(id)); }}
                                        >
                                            {t('View Hours')}
                                        </span>
                                    </OverlayTrigger>
                                }</>),
                            maxWidth: 70,
                        },
                        {
                            Header: 'Actions',
                            id: 'actions',
                            accessor: ({ id, status, int_id, assignee_id, email, payroll_project_id, data, pm_has_manage_projects }) => this.renderTableActionButtons(id, aclAllowed, t, status, int_id, assignee_id, email, payroll_project_id, data, !!pm_has_manage_projects),
                            maxWidth: 120,
                        },
                    ]}
                    header={
                        <GenericFilter
                            filters={filters}
                            setFilter={(name, value) => this.props.projectStore.setFilter(name, value)}
                            onFilter={() => this.props.projectStore.onFilter()}
                            loading={loading}
                            hasStatusFilter={true}
                            statusOptions={statusOptions}
                            searchFilterPlaceholder={"Search by project name or number"}
                        />
                    }
                    tableHeader={this.props.t('Projects')}
                    splitHeader={true}
                    forceReload={this.props.projectStore.deleteSuccess}
                    filters={appliedFilters}
                    lastListLoadTime={this.props.projectStore.lastListLoadTime}
                    requestData={(params) => this.props.projectStore.loadList({ ...params, includeIntegrationDetails })}
                    pageSize={50}
                    handlePageChange={(page, isEdit) => this.handlePageChange(page, isEdit)}
                    page={page} //new page props to maintain page from parent//
                    isPageAddedOrEdited={isPageAddedOrEdited} //to load same page after edit//
                    lastColoumLoadTime={lastColoumLoadTime}
                    getRowClassName={this.getRowClassName}
                    onRowClick={(row) => {
                        const current = this.props.projectStore.lastInteractedId;
                        this.props.projectStore.setLastInteractedId(current === row.id ? null : row.id);
                    }}
                >
                    {aclAllowed('project-add') && (
                        this.renderProjectHeader()
                    )}
                </GenericList>
                <Modal
                    size="lg"
                    dialogClassName="modal-70w"
                    show={!!nowEditingId && modalName === 'assignees'}
                    onHide={() => this.setState({ nowEditingId: null, modalName: '' })}
                    className={`right modal_revised`}
                >
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center m-0">{this.props.t('Project members')}</Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            alt='close_button'
                            onClick={() => this.setState({ nowEditingId: null, modalName: '' })}
                        />
                    </Modal.Header>

                    <Modal.Body style={{ minHeight: '80vh' }}>
                        <ModalEditor id={nowEditingId} afterSave={() => this.afterChangeMembers()} />
                    </Modal.Body>
                </Modal>
                <Modal
                    size="sm"
                    show={!!nowEditingId && modalName === 'pm_rules'}
                    onHide={() => this.setState({ nowEditingId: null, modalName: '', pmList: [] })}
                >
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center m-0">{t('Managers')}</Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            alt="close_button"
                            onClick={() => this.setState({ nowEditingId: null, modalName: '', pmList: [] })}
                        />
                    </Modal.Header>
                    <Modal.Body>
                        {pmRulesLoading
                            ? <LoadingSpinner />
                            : pmList.length
                                ? <ul className="list-unstyled m-0">
                                    {pmList.map(pm => (
                                        <li key={pm.user_id} className="py-1 border-bottom">{pm.full_name}</li>
                                    ))}
                                </ul>
                                : <p className="text-center text-muted mt-3">{t('No managers assigned')}</p>
                        }
                    </Modal.Body>
                </Modal>
                <Modal
                    size="lg"
                    dialogClassName="custom-big-modal"
                    show={!!nowEditingId && modalName === 'project_view'}
                    onHide={() => this.setState({ nowEditingId: null, modalName: '' })}
                >
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center m-0">{this.props.t('Project details')}</Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            alt='close_button'
                            onClick={() => this.setState({ nowEditingId: null, modalName: '' })}
                        />
                    </Modal.Header>
                    <Modal.Body style={{ minHeight: '80vh' }}>
                        <ProjectView id={nowEditingId} />
                    </Modal.Body>
                </Modal>
                {showImportComponent &&
                    <ProjectImport
                        handleImportModal={this.handleImportModal}
                    />
                }
                {showSyncTaskModal &&
                    <ProjectTaskImport
                        handleTaskImportModal={this.handleTaskImportModal}
                        fromProjectList={true}
                        selectedProjectIntId={selectedProjectIntId}
                        selectedProjectId={selectedProjectId}
                    />
                }
            </Fragment>
        );
    }
}
export default inject('projectStore', 'userStore', 'commonStore',)(applicationRouter(withPermissions(withLocalization(observer(ProjectsList)))));
